// extracted by mini-css-extract-plugin
export default {"button":"button__3FoGa","defaultColors":"defaultColors__MECCr","block":"block__2s3f_","large":"large__1Irps"};
    if(module.hot) {
      // 1778491671637
      var cssReload = require("../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  